import React, { useState } from "react"
import { Button, Card, CardBody, Collapse, Tooltip } from "reactstrap"
import { useNavigate } from "react-router-dom"
import CustomHeaderTitle from "components/Common/CustomHeaderTitle"
import GeneralTables from "components/Common/GeneralTable"
import ActionColumns from "components/Common/GeneralTable/ActionColumns"
import CSAlert from "components/Alert/ConfirmationAlert"
import ProviderInFilter from "./ProviderInFilter"
import ProviderInTotalBox from "./ProviderInTotalBox"
import { downloadURL } from "api/APP_URL"
import CurrencyComponent from "components/Common/CurrencyComponent"

const ProviderInListComponent = ({
  data,
  error,
  loading,
  onPageClick,
  onSearch,
  onChangeRowNumber,
  onChangeOrdering,
  onClickDelete,
  onAllDeleteClicked,
  onAdvancedSearchSubmit,
  permissions,
  onClickDetail,
  onExportBtnClick,
  onUploadFileForMultipleReceipts,
  exportStatus,
  onRejectReceipt,
  onAcceiptReceipt,
  onTransferClick,
}) => {
  const navigate = useNavigate()
  const [ids, setIds] = useState([])
  const [filterOpen, setFilterOpen] = useState(false)
  const [tooltipOpen, setTooltipOpen] = useState({})

  // Store record in thier Dispatch when a checkbox is clicked
  const onCheckboxClick = (e, id) => {
    const check = ids.includes(id)
    if (check) {
      const updated = ids.filter(myId => myId !== id)
      setIds(updated)
    } else {
      setIds(prev => {
        return [...prev, id]
      })
    }
  }

  // Handle bulk deletion when top delete button is clicked and confirmed
  const onAllDeleteHandler = async () => {
    const results = await CSAlert({
      title: "Are you sure delete?",
    })
    if (results.isConfirmed) {
      onAllDeleteClicked(ids)
    }
  }

  // select/deselect record lists for upload file
  const onUploadBtnhandler = async file => {
    const results = await CSAlert({
      title: "Are you sure upload file?",
    })
    if (results.isConfirmed) {
      onUploadFileForMultipleReceipts(ids, file)
    }
  }

  // Handle parent checkbox status change to select/deselect all items
  const onParentCheckChange = status => {
    if (status) {
      const all = data?.data.map(dt => dt.id)
      setIds(all)
    } else {
      setIds([])
    }
  }

  // Callback function to toggle the advanced search filter visibility when the button is clicked
  const onAdvancedSearchHandler = result => {
    setFilterOpen(result)
  }

  return (
    <React.Fragment>
      <Card>
        <CardBody>
          {/*
            CustomHeaderTitle Component Props:
            
            - loading: Boolean flag to display loading state
            - title: String to display as the header title
            - rowCount: Boolean to show/hide the row number selector
            - lgColumn: Number to control the width of columns based on layout needs
            - onChangeRowNumber: Callback function to handle row number selection change
            - orderingList: Boolean to show/hide ordering dropdown
            - onChangeOrdering: Callback function triggered when the ordering option is changed
            - searchBox: Boolean to show/hide search input box
            - onSearchHandler: Function called on key up in the search box
            - rightBtn: Boolean to show/hide right-side button (for example, a back button)
            - rightBtnTitle: String for setting the right button's label
            - rightBtnRoute: Route for the right button's navigation
            - exportBtn: Boolean to show/hide export button
            - onExportBtnClick: Callback for when the export button is clicked
            - exportBtnLoading: Boolean flag to show loading state during export functionality
            - advnacedSearchBtn: Boolean to show/hide advanced search button
            - advnacedSearchBtnTitle: String to display the advanced search button label
            - onAdvancedSearch: Callback function when the advanced search button is clicked (used to toggle collapse)
            - orderingOptions: Array of options to populate the ordering dropdown (value and name pair)
          */}
          <CustomHeaderTitle
            loading={loading}
            title={"List"}
            rowCount={true}
            onChangeRowNumber={onChangeRowNumber}
            orderingList={true}
            onChangeOrdering={onChangeOrdering}
            searchBox={true}
            onSearchHandler={onSearch}
            rightBtn={true}
            rightBtnTitle={"Add Receipt"}
            rightBtnRoute={"/add-provider-receipts"}
            deleteBtn={permissions.includes("delete-provider-in")}
            onAllDeleteHandler={onAllDeleteHandler}
            advnacedSearchBtn={true}
            advnacedSearchBtnTitle={"Filter"}
            exportBtn={true}
            onExportBtnClick={onExportBtnClick}
            exportBtnLoading={exportStatus?.loading}
            onAdvancedSearch={onAdvancedSearchHandler}
            enableUploadBtn={true}
            onUploadBtnhandler={onUploadBtnhandler}
            orderingOptions={[
              { value: "id", name: "ID" },
              { value: "item_name", name: "Item Name" },
              { value: "unfp_item_name", name: "UNFPA Item Name" },
            ]}
          />
          {/* Provider Receipt Total Box Component  */}
          <ProviderInTotalBox totals={data?.totals} />
          <Collapse isOpen={filterOpen}>
            {/* Provider Receipt Filter Component  */}
            <ProviderInFilter
              loading={loading}
              onAdvancedSearchSubmit={onAdvancedSearchSubmit}
            />
          </Collapse>

          {/*
            GeneralTables Component Props:

            - data: Array containing the data to be displayed in the table
            - loading: Boolean indicating the loading state of the table
            - parentCheckbox: Boolean to determine if a parent checkbox is included in the table
            - headers: Array of strings representing the column headers for the table
            - pagination: Object containing pagination metadata and a callback function:
                - meta: Object for pagination details (e.g., page number, total items)
                - onPageClick: Callback function to handle page number changes
            - renderItem: Function to render each row/item in the table using the provided data
          */}
          <GeneralTables
            data={data?.data}
            loading={loading}
            parentCheckbox={true}
            onParentCheckChange={onParentCheckChange}
            headers={[
              "SN",
              "DS NUMBER",
              "PROJECT",
              "FUND CODE",
              "SHIPMENT",
              "WAYBILL NUMBER",
              "PROVIDER",
              "TYPE",
              "OTHER SOURCE",
              "UNFPA ITEM ID",
              "IP- ITEM DESCRIPTION",
              "UNFPA UNIT OF MEASURE (UOM))",
              "IP UNIT UOM",
              "UNIT PRICE (AS PER UNFPA)",
              "UNIT PRICE (AS PER IP UOM)",
              "BATCH NUMBER",
              "EXPIRE DATE",
              "QUANTITY (UNFPA UOM)",
              "QUANTITY (IP UOM)",
              "COMMENT",
              "RECEIPT DATE",
              "Action",
            ]}
            pagination={{ meta: data?.meta, onPageClick: onPageClick }}
            renderItem={(pIn, index) => (
              <tr key={index}>
                <th scope="row">
                  {" "}
                  <div className="form-check form-checkbox-outline form-check-primary mb-3">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id={`checkbox-${pIn.id}`}
                      checked={ids.includes(pIn.id)}
                      onChange={e => onCheckboxClick(e, pIn.id)}
                    />
                    <label
                      className="form-check-label"
                      htmlFor={`checkbox-${pIn.id}`}
                    >
                      {data?.meta?.from + index}
                    </label>
                  </div>
                </th>
                <td>{pIn?.receipt_number || "-"}</td>
                <td>{pIn?.project?.name}</td>
                <td>{pIn?.fund_code?.code || "-"}</td>
                <td>{pIn?.shipment?.name || "-"}</td>
                <td>{pIn?.waybill_number || "-"}</td>
                <td>{pIn?.provider?.title}</td>
                <td>{pIn?.type || "Receipt"}</td>
                <td>{pIn?.other_source || "-"}</td>
                <td>{pIn?.item?.unfp_item_name}</td>
                <td>{pIn?.item?.ip_item_description}</td>
                <td>
                  {pIn?.item.uom} &nbsp;
                  {pIn?.unit_uom_quantity_per_unfpa > 1 &&
                    pIn?.unit_uom_quantity_per_unfpa}
                </td>
                <td>
                  {pIn?.item.ip_unit_umo} &nbsp;
                  {pIn?.unit_umo_quantity_per_ip > 1 &&
                    pIn?.unit_umo_quantity_per_ip}
                </td>
                <td>
                  <CurrencyComponent
                    currency={pIn?.currency}
                    amount={pIn.unit_price_per_unfpa}
                  />
                </td>
                <td>
                  <CurrencyComponent
                    currency={pIn?.currency}
                    amount={pIn.unit_price_per_ip}
                  />
                </td>
                <td>{pIn.batch_number}</td>
                <td>{pIn.expire_date}</td>
                <td>{pIn.first_in_qty_per_unfpa}</td>
                <td>{pIn.first_in_qty_per_ip}</td>
                <td>{pIn.lost_quantity + " " + pIn.lost_comment}</td>
                <td>{pIn.date}</td>
                <td>
                  {pIn.deleteStatus === 0 ? (
                    <React.Fragment>
                      {/* Render action columns with Edit and Delete options for each receipt  */}
                      {pIn?.provided_status === 0 ? (
                        <ActionColumns
                          data={pIn}
                          enableAccept={permissions.includes(
                            "update-provider-in"
                          )}
                          enableDelete={permissions.includes(
                            "delete-provider-in"
                          )}
                          enableDetail={true}
                          onAcceptClick={onAcceiptReceipt}
                          onClickDelete={onRejectReceipt}
                          onClickDetail={onClickDetail}
                          enableDocumentLink={pIn?.document}
                          documentLink={`${downloadURL}/${pIn?.document}`}
                        />
                      ) : (
                        <div className="d-flex gap-3 align-items-center">
                          <ActionColumns
                            data={pIn}
                            enableEdit={
                              permissions.includes("update-provider-in") &&
                              ["", null, 0].includes(pIn?.provided_by)
                            }
                            enableDelete={
                              permissions.includes("delete-provider-in") &&
                              ["", null, 0].includes(pIn?.provided_by)
                            }
                            enableDetail={true}
                            editRoute={`/edit-provider-receipts/${pIn.id}`}
                            onClickDelete={onClickDelete}
                            onClickDetail={onClickDetail}
                            enableDocumentLink={pIn?.document}
                            documentLink={`${downloadURL}/${pIn?.document}`}
                          />
                          {pIn?.provided_by &&
                            pIn?.in_qty_per_ip > 0 &&
                            permissions.includes("create-provider-transfer") &&
                            (pIn?.has_pending_transfer ? (
                              <>
                                <i
                                  className="mdi mdi-lock font-size-18 text-warning"
                                  id={`lock-transfer-${pIn.id}`}
                                  style={{ cursor: "default" }}
                                  onMouseEnter={() =>
                                    setTooltipOpen(prev => ({
                                      ...prev,
                                      [`lock-transfer-${pIn.id}`]: true,
                                    }))
                                  }
                                  onMouseLeave={() =>
                                    setTooltipOpen(prev => ({
                                      ...prev,
                                      [`lock-transfer-${pIn.id}`]: false,
                                    }))
                                  }
                                />
                                <Tooltip
                                  placement="top"
                                  isOpen={
                                    !!tooltipOpen[`lock-transfer-${pIn.id}`]
                                  }
                                  target={`lock-transfer-${pIn.id}`}
                                  toggle={() =>
                                    setTooltipOpen(prev => ({
                                      ...prev,
                                      [`lock-transfer-${pIn.id}`]:
                                        !prev[`lock-transfer-${pIn.id}`],
                                    }))
                                  }
                                >
                                  Pending return request - locked
                                </Tooltip>
                              </>
                            ) : (
                              <>
                                <button
                                  className="btn btn-sm btn-outline-warning"
                                  id={`transfer-${pIn.id}`}
                                  onClick={() => onTransferClick(pIn)}
                                  style={{
                                    padding: "0.25rem 0.5rem",
                                    fontSize: "0.75rem",
                                  }}
                                  onMouseEnter={() =>
                                    setTooltipOpen(prev => ({
                                      ...prev,
                                      [`transfer-${pIn.id}`]: true,
                                    }))
                                  }
                                  onMouseLeave={() =>
                                    setTooltipOpen(prev => ({
                                      ...prev,
                                      [`transfer-${pIn.id}`]: false,
                                    }))
                                  }
                                >
                                  <i className="mdi mdi-arrow-left-bold" />{" "}
                                  Re-allocation
                                </button>
                                <Tooltip
                                  placement="top"
                                  isOpen={!!tooltipOpen[`transfer-${pIn.id}`]}
                                  target={`transfer-${pIn.id}`}
                                  toggle={() =>
                                    setTooltipOpen(prev => ({
                                      ...prev,
                                      [`transfer-${pIn.id}`]:
                                        !prev[`transfer-${pIn.id}`],
                                    }))
                                  }
                                >
                                  Return back to source provider
                                </Tooltip>
                              </>
                            ))}
                        </div>
                      )}
                    </React.Fragment>
                  ) : (
                    <Button className="btn btn-info btn-sm">Pending</Button>
                  )}
                </td>
              </tr>
            )}
          />
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

export default ProviderInListComponent
